// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MajorSelectMenu_wrapper__1m2LJ","select":"MajorSelectMenu_select__1TSNK","button":"MajorSelectMenu_button__RWyR0"};